// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3WFcS","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__27UU_"};